/**
 * Type definitions and color maps for the Admin Customers UI.
 * The page derives the actual data shape from the backend Customer
 * (see src/services/customersApi.ts) and adapts it into these types.
 */

export interface CustomerStat {
  label: string;
  value: string;
  change: string;
  iconBg: string;
  iconColor: string;
}

export type TierType = 'Gold' | 'Silver' | 'Bronze';
export type HealthType = 'Green' | 'Yellow' | 'Red';
export type ScoreTrend = 'up' | 'down';

export interface CustomerItem {
  id: number;
  name: string;
  location: string;
  tier: TierType;
  score: number;
  scoreTrend: ScoreTrend;
  revenue: number;
  marginPercent: number;
  ordersPerWeek: number;
  aov: number;
  health: HealthType;
  claims: number;
}

export const tierColors: Record<TierType, { bg: string; color: string }> = {
  Gold: { bg: '#FEF3C7', color: '#D97706' },
  Silver: { bg: '#F3F4F6', color: '#6B7280' },
  Bronze: { bg: '#FEE2E2', color: '#DC2626' },
};

export const healthColors: Record<HealthType, { bg: string; color: string }> = {
  Green: { bg: '#D1FAE5', color: '#059669' },
  Yellow: { bg: '#FEF3C7', color: '#D97706' },
  Red: { bg: '#FEE2E2', color: '#DC2626' },
};
